// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__aq3ns","loader":"Loader_loader__w4q0Y","rotation":"Loader_rotation__SzZNk"};